import script from "./popup-intercept.vue?vue&type=script&setup=true&lang=ts"
export * from "./popup-intercept.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__